import { Component, HostListener } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule, NgFor } from '@angular/common';


type MicrosModel = {
  slug: string;
  title: string;
  views: string[]; // archivos dentro de assets/images/microscopios
};


@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterLink, NgFor, CommonModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {




  // Ejemplo: connect.component.ts
lisItems = [
  {
    title: 'Registro de atención',
    icon: 'bi-person-vcard',
    description:
      'Incluye la identificación y clasificación del paciente y los exámenes clínicos. Gestión de códigos de barras para la identificación y trazabilidad de las muestras, así como para la integración con los analizadores.'
  },
  {
    title: 'Recolección y verificación de muestras',
    icon: 'bi-clipboard2-check',
    description:
      'Incluye fecha, hora y persona responsable, así como la razón de rechazo y las acciones correctivas a tomar.'
  },
  {
    title: 'Emisión de hojas de trabajo',
    icon: 'bi-file-earmark-spreadsheet',
    description:
      'Por área de prueba pendientes de registro para facilitar el procesamiento por lotes de muestras, el ingreso de resultados y la posterior descarga al sistema.'
  },
  {
    title: 'Registro y validación de resultados',
    icon: 'bi-shield-check',
    description:
      'Incluye alertas de resultados patológicos, de emergencia, de muestra no recolectada y de exámenes rechazados; visualización de rangos de referencia; síntomas u observaciones registradas en la atención; y consultas históricas para apoyar la validación o rechazo de resultados.'
  },
  {
    title: 'Impresión de historial de resultados',
    icon: 'bi-printer',
    description:
      'Historial gráfico de resultados para exámenes cuantificables (comportamiento en el tiempo) y “historial columnar” de resultados para exámenes cuantificables o cualitativos en un periodo.'
  }
];




  images = [
      'assets/brand/brand_1.png',
      'assets/brand/brand_2.png',
      'assets/brand/brand_3.png', // 👈 centro (por defecto)
      'assets/brand/brand_4.png',
      'assets/brand/brand_5.png',
    ];


     selected = 2;     // card del centro seleccionada por defecto
  hover = -1;       // índice en hover (solo efecto visual)

  select(i: number) { this.selected = i; }

  /** Transform con separación por offset + rotación contenida + escala */
  getTransform(i: number): string {
    const offset = i - this.selected;                 // distancia al centro
    const baseScale = i === this.selected ? 1.06 : 0.88;
    const hoverBoost = this.hover === i ? 0.04 : 0;
    const scale = baseScale + hoverBoost;

    // Rotación contenida (para que se “lean” casi completas)
    const rotate = Math.max(-10, Math.min(10, offset * 4));

    // Nota: var(--gap) viene del CSS y se adapta al tamaño de la carta
    return `
      translate(-50%, -50%)
      translateX(calc(${offset} * var(--gap)))
      rotate(${rotate}deg)
      scale(${scale})
    `.replace(/\s+/g, ' ');
  }

  /** Z-index para que la seleccionada quede encima */
  getZ(i: number): number {
    const depth = 100 - Math.abs(i - this.selected);
    return this.hover === i ? depth + 2 : depth;
  }

  /** Accesible: permite seleccionar con Enter o Espacio */
  onKey(i: number, ev: KeyboardEvent) {
    if (ev.key === 'Enter' || ev.key === ' ') {
      ev.preventDefault();
      this.select(i);
    }
  }

  // En pantallas muy pequeñas reducimos un poquito la escala global
  @HostListener('window:resize') onResize() {}




  
  // Carrusel Serie M
  serieMSlides = [
    { src: 'assets/images/Alpsc200.png',    alt: 'ALPSC 200' },
    { src: 'assets/images/Alpsc200fd.png',  alt: 'ALPSC 200 FD' },
    { src: 'assets/images/Alpsc800f.png',   alt: 'ALPSC 800 F' },
    { src: 'assets/images/Alpsc1600.png',   alt: 'ALPSC 1600' },
  ];

  // --- CATEGORÍAS (imagenes en assets/categories/*.png) ---
  categories = [
    { slug: 'centrifuges',  name: 'Centrífugas',  file: 'centrifuges.png' },
    { slug: 'chemistry',    name: 'Bioquímica',    file: 'chemistry.png' },
    { slug: 'hematology',   name: 'Hematología',   file: 'hematology.png' },
    { slug: 'immunology',   name: 'Inmunología',   file: 'immunology.png' },
    // { slug: 'infusion',     name: 'Infusión',     file: 'infusion.png' },
    { slug: 'microscopes',  name: 'Microscopios',  file: 'microscopes.png' },
    { slug: 'radiology',    name: 'Radiología',    file: 'radiology.png' },
    { slug: 'urinalysis',   name: 'Uroanálisis',   file: 'urinalysis.png' },
    // agrega aquí las que quieras; el carrusel se adapta automáticamente
  ];

// …lo que ya tienes arriba

// Duplicado para loop infinito
get categoriesLoop() {
  return [...this.categories, ...this.categories];
}

// ✅ trackBy: usa slug + índice (porque al duplicar hay slugs repetidos)
trackByCategory = (index: number, item: { slug: string }) => `${item.slug}-${index}`;
// Ya tienes this.categories. Mantén tu arreglo como lo tienes.

// Para trackBy (mejora rendimiento)

// Crea los slides de 5 elementos
get categorySlides() {
  const size = 5;
  const out: typeof this.categories[] = [];
  for (let i = 0; i < this.categories.length; i += size) {
    out.push(this.categories.slice(i, i + size));
  }
  // Si el último slide queda corto, lo rellenamos duplicando desde el inicio (para que siempre se vean 5)
  if (out.length) {
    const last = out[out.length - 1];
    while (last.length < size) last.push(this.categories[last.length % this.categories.length]);
  }
  return out;
}








public microsModels: MicrosModel[] = [
  {
    slug: 'astre1',
    title: 'ASTREO® 100',
    views: [
      'Astreo 100 ESDE.png',
      'Astreo 100 ESIZ.png',
      'Astreo 100 F.png',
      'Astreo 100 LD.png',
      // hay un “LIZ”, pero mostramos solo 4
      // 'Astreo 100 LIZ.png',
    ],
  },
  {
    slug: 'astre3',
    title: 'ASTREO® 300',
    views: [
      'Astreo 300 ESDE.png',
      'Astreo 300 ESIZ.png',
      'Astreo 300 F.png',
      'Astreo 300LD.png', // (sin espacio)
    ],
  },
  {
    slug: 'astre3p',
    title: 'ASTREO® 300plus',
    views: [
      'Astreo 300plus ESDE.png',
      'Astreo 300plus ESIZ.png',
      'Astreo 300plus F.png',
      'Astreo 300plusLD.png', // (sin espacio)
    ],
  },
  {
    slug: 'astre6',
    title: 'ASTREO® 620',
    views: [
      'Astreo 620 ESDE.png',
      'Astreo 620ESIZ.png', // (sin espacio)
      'Astreo 620 F.png',
      'Astreo 620 LD.png',
    ],
  },
];

// índice seleccionado por modelo
public selectedViewIndex: Record<string, number> = {
  astre1: 0,
  astre3: 0,
  astre3p: 0,
  astre6: 0,
};

public imgPath(file: string): string {
  return `assets/images/microscopios/${file}`;
}

public selectView(slug: string, idx: number): void {
  this.selectedViewIndex[slug] = idx;
}

public trackBySlug(_: number, m: MicrosModel): string {
  return m.slug;
}






}
